import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchLoadingSectionLine } from '#/modules/search/components/Loading/SearchLoadingSectionLine';
import type { SearchType } from '#/modules/search/types/SearchType';
import { LISTING_TYPE_HUMAN_NAME_MAP } from '#/utils/constants/general/listingTypeHumanNameMap';
import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP } from '#/utils/constants/general/listingTypePluralHumanNameMap';

type Props = {
  count: number | null;
  searchType: SearchType;
};

const formatNumber = (num: number) =>
  new Intl.NumberFormat('en-US').format(num);

export function SearchResultsHeaderCount({ count, searchType }: Props) {
  const { i18n } = useI18n();
  if (count === null)
    return <SearchLoadingSectionLine width={64} height={20} />;

  const text =
    count === 1
      ? i18n('1 %(searchType)s', {
          searchType: LISTING_TYPE_HUMAN_NAME_MAP(i18n)[searchType],
        })
      : i18n('%(count)s %(searchType)s', {
          count: formatNumber(count),
          searchType: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP(i18n)[searchType],
        });

  return (
    <Text
      tag="h2"
      styleAs="body"
      display={['block', 'block', 'block', 'inline-block']}
      fontSize="16px!important"
      mb={0}
      qaId="result-count"
      data-result-count={count}
    >
      {text}
    </Text>
  );
}
